import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ProjectList = Loadable(lazy(() => import('./ProjectList')));
const AddProject = Loadable(lazy(() => import('./AddProject')));

const ProjectRoutes = [
  {
    path: '/project/list',
    element: <ProjectList />,
    auth: authRoles.admin,
  },
  {
    path: '/Project/manage',
    element: <AddProject />,
    auth: authRoles.admin,
  },
];

export default ProjectRoutes;
